// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
import { useCallback } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { LOCAL_STORAGE_KEYS, NETWORK_RESPONSE_STATUS } from '../../utils/global_variables';
import { userLogout } from '../../redux/actions/auth';
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from '../../components';
import { updateAddEndNoticeAcceptedOrRejected } from '../../redux/actions/addEndumAndNotices';
import { acceptorRejectAddendumAndNotices } from '../../apis/nontransactional';


function AddEndumAndNoticeRejectModal({ currentInDex, show, htmlContent, setShow, anddEndumNoticesInfo }) {

    const dispatch = useDispatch();
    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --Start
    const handleAccept = useCallback(async () => {
        const payload = {
            accept_or_reject_action: "REJECT",
            client_mac_address: "",
            notice_id: anddEndumNoticesInfo[currentInDex - 1]?.notice_id// current index
        };

        const objResp = await acceptorRejectAddendumAndNotices(payload);
        if (objResp?.status === NETWORK_RESPONSE_STATUS?.SUCCESS) {
            setShow(false);
            dispatch(userLogout()).then(() => {
                window.location.replace('/');
                localStorage?.removeItem(LOCAL_STORAGE_KEYS.ACCEPTED_NOTICES_ID);
                localStorage?.removeItem(LOCAL_STORAGE_KEYS.REJECTED_NOTICES_ID);
                localStorage?.removeItem(LOCAL_STORAGE_KEYS.CHECKBOX_NOTICES_ID);
            }).catch(() => {
                localStorage?.removeItem(LOCAL_STORAGE_KEYS.ACCEPTED_NOTICES_ID);
                localStorage?.removeItem(LOCAL_STORAGE_KEYS.REJECTED_NOTICES_ID);
                localStorage?.removeItem(LOCAL_STORAGE_KEYS.CHECKBOX_NOTICES_ID);
                window.location.replace('/');
            });
        } else { }
        dispatch(updateAddEndNoticeAcceptedOrRejected(false));
    }, [anddEndumNoticesInfo, setShow, currentInDex, dispatch]);
    // Ameersha N : 09-02-2024 : BT-116461 Breeze - Addendum and Notices --End

    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --Start
    const handleReject = useCallback(() => {
        setShow(false);
    }, [setShow]);
    // Ameersha N : 17-11-2023 : BT-116461 Breeze - Addendum and Notices --End
    return (
        <BzModal size='sm' show={show} centered>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text'>Logging Off</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={handleReject}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0 mt-2 mb-3'>
                        <Col className='d-flex justify-content-start'>
                            <div className='font-regular font-size4 color-text' dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0 justify-content-end'>
                        <Col md={10} className='d-flex align-items-center'>
                            <BzButton className='btn btn-md btn-block btn-outline me-3' autoFocus onClick={() => handleReject()}>Cancel</BzButton>
                            <BzButton className='btn btn-md btn-block btn-primary' onClick={() => handleAccept()}>Continue</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
    );
}

export default AddEndumAndNoticeRejectModal;
// Ameersha N : 27-11-2023 : BT-116461 Breeze - Addendum and Notices --End